
import PostForm from "./PostForm";

const NewPost = () => {
  return <PostForm mode="create" />;
};

export default NewPost;
